
import { computed } from 'vue';
import { defineComponent, PropType } from 'vue';

type ButtonVariant = 'primary' | 'ghost' | 'danger';
type ButtonSize = 'large' | 'normal' | 'small';

export default defineComponent({
  props: {
    ariaLabel: {
      type: String,
      default: '',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    size: {
      type: String as PropType<ButtonSize>,
      default: 'normal',
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String as PropType<ButtonVariant>,
      default: 'primary',
    },
  },

  emits: ['click'],

  setup(props) {
    const typeClass = computed(() => `button--${props.type}`);
    const sizeClass = computed(() => `button--${props.size}`);
    const iconClass = computed(() => `fa-${props.icon}`);
    const fullWidthClass = computed(() =>
      props.fullWidth ? 'button--full' : '',
    );

    return { typeClass, sizeClass, iconClass, fullWidthClass };
  },
});
